import axios from 'axios'
import * as Cookie from 'js-cookie'

const headers = {
    'X-CSRFToken': Cookie.get('csrftoken'),
    Accept: 'application/json',
    'Content-Type': 'application/json',
}

const fetch = {
    get(url) {
        return axios({
            url,
            headers,
            method: 'get',
            withCredentials: true,
        })
    },

    post(url, data) {
        return axios({
            url,
            headers,
            method: 'post',
            withCredentials: true,
            data,
        })
    },

    put(url, data) {
        return axios({
            url,
            headers,
            method: 'put',
            withCredentials: true,
            data,
        })
    },

    delete(url, data) {
        return axios({
            url,
            headers,
            method: 'delete',
            withCredentials: true,
            data,
        })
    },
}

export default fetch
